import { render, staticRenderFns } from "./InviteFriendsForm.vue?vue&type=template&id=242ba884&"
import script from "./InviteFriendsForm.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports